module.exports = __webpack_public_path__ + "static/media/ceLogo.d51f2bfc.png";